import React, { Component } from 'react';
import { auth } from '../firebase';
import { db, storr } from '../firebase/firebase';
import { message, Popover, Card, Button } from "antd";
import {
  Link,
} from 'react-router-dom'


class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      pendingData: { welcomeImg: "", title: "", location: "", image: "", inputDisabled: false, disabled: true },
    }
    this.getImg()
  }
  componentDidMount() {
    auth.onAuthStateChanged((user) => {
      if (user) {
        this.setState({ email: user.email })
      } else {
        console.log('no user')
      }
    });
  }
  clearInputFile = () => {
    var tempB = this.state.pendingData
    document.getElementById("uploadCaptureInputFile").value = ""
    tempB.file = null
    tempB.disabled = true
    this.setState({ pendingData: tempB })
  }


  handlePreuploadFile = (event) => {
    var abb = this.state.pendingData;

    abb.file = event.target.files[0]

    var f = abb.file

    if (f) {
      window.URL = window.URL || window.webkitURL

      var img = new Image()
      img.src = window.URL.createObjectURL(f)

      if (f.type === 'image/png' || f.type === 'image/jpeg') {
        console.log("accepted file format")
        if (f.size < 100000000) {
          var self = this
          img.onload = function () {
            var width = img.naturalWidth,
              height = img.naturalHeight;

            window.URL.revokeObjectURL(img.src);
            var ww = 1080
            var hh = 800
            if (width == ww && height == hh) {
              message.info("You inputed " + abb.file.name)
              abb.disabled = false
              self.setState({ pendingData: abb });
            }
            else {
              message.info('Please ensure the image is w' + ww + ' x h' + hh + '. Your image width is ' + width + ' and height is ' + height)
              document.getElementById("uploadCaptureInputFile").value = ""
              abb.file = null
              abb.disabled = true
            }
          }
        } else {
          message.error('File too big')
          document.getElementById("uploadCaptureInputFile").value = ""
          abb.file = null
          abb.disabled = true
        }
      } else {
        message.error('Unaccepted file type')
        document.getElementById("uploadCaptureInputFile").value = ""
        abb.file = null
        abb.disabled = true
      }
    } else {
      document.getElementById("uploadCaptureInputFile").value = ""
      abb.file = null
      abb.disabled = true
    }



    this.setState({ pendingData: abb });
  }

  handlefile = (event) => {
    var ajj = this.state.pendingData
    ajj.disabled = true
    this.setState({ pendingData: ajj })

    message.loading('Uploading...')

    var tempFile = ajj.file

    var ext = tempFile.name.substring(tempFile.name.lastIndexOf('.'), tempFile.name.length)
    // Create a reference with an initial file path and name
    var ref = storr.ref('welcome' + ext);
    // Get the download URL
var self = this
    // Upload file and metadata to the object 'images/mountains.jpg'
    var uploadTask = storr.ref('welcome' + ext).put(ajj.file).then(function (doc) {

      ref.getDownloadURL().then(function (url) {
        // console.log("putting link into database " + url)

        // Insert url into an <img> tag to "download"
        //open the link of the url.
        // window.open(url, '_blank');
        db.collection("welcome").doc('1').set({
          ext: ext,
          image: url
        })
        document.getElementById("uploadCaptureInputFile").value = ""
        ajj.file = null
        ajj.inputDisabled = false
        self.setState({ pendingData: ajj })
        message.destroy()
        message.success("Uploaded successfully")
      })

    });


  }


  async getImg() {
    var akk = this.state.pendingData;

    await db.collection("welcome").onSnapshot(snapshot => {
      let locationList = [];
      snapshot.forEach(function (doc) {
        // doc.data() is never undefined for query doc snapshots
        // console.log(doc.id, " => ", doc.data());
        const todo = doc.data()
        todo.id = doc.id

        akk.welcomeImg = todo
      })
      // Anytime the state of our database changes, we update state
      this.setState({ pendingData: akk });
    })
  }

  render() {
    return (
      <div> 
        <h1 className='block'>Dashboard</h1>
        <Card className="cardy" title='Promotions'>
          <Button className="gutter-box" type="primary" size="large" >
            <Link to='/dashboard/promotions/'>Manage Promotions</Link>
          </Button>
          <Button className="gutter-box" type="secondary" size="large" >
            <Link to='/dashboard/promotions/archive'>Promotions Archive</Link>
          </Button>
          <br />
        </Card>
        <Card className="cardy" title='News'>
          <Button className="gutter-box" type="primary" size="large" >
            <Link to='/dashboard/news/'>Manage News</Link>
          </Button>
          <Button className="gutter-box" type="secondary" size="large">
            <Link to='/dashboard/news/archive'>News Archive</Link>
          </Button>
          <br />
        </Card>
        <Card className="cardy" title='Welcome Image'>
          <a href={this.state.pendingData.welcomeImg.image} target="_blank"><img src={this.state.pendingData.welcomeImg.image} alt={this.state.pendingData.welcomeImg.image} className="welcomey">
          </img></a>
          <br />
          <div className="gutter-box">
            <Button
              type="danger"
              onClick={this.clearInputFile}
              disabled={this.state.pendingData.inputDisabled}
              ghost
            >
              Clear file
                </Button>
          </div>
          <Popover content={<div>Recommended size <strong>1080(w) x 800(h)</strong> px<hr></hr>png file only</div>}>
            <input type="file"
              id="uploadCaptureInputFile"
              accept=".png"
              onChange={this.handlePreuploadFile}
              disabled={this.state.pendingData.inputDisabled}
            />
          </Popover>
          <Button
            className="gutter-box"
            type="primary"
            onClick={this.handlefile}
            disabled={this.state.pendingData.disabled}
          >
            Upload
          </Button>
        </Card>

        {/* {this.state.email == 'cc@cc.cc' ? <Button type="primary" size="large" ><Link to='admin'>admin</Link></Button>:<div/>} */}
      </div>
    );

  }

}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/dashboard.js